
import Vue from "vue";
import { Component, Prop } from 'vue-property-decorator';
import BackIcon from '@components/icons/icon-back.svg';
import PlusIcon from '@components/icons/icon-plus.svg';
import CheckIcon from '@components/icons/icon-check.svg';
import { NavigationButton } from "@components/new-styleguide/AppHeader.vue";

@Component({
  name: 'AppEditableHeader',
  components: {
    BackIcon,
    PlusIcon,
    CheckIcon
  }
})
export default class AppEditableHeader extends Vue {
  @Prop({ required: true })
  private value: string;

  @Prop({ required: true })
  private back: NavigationButton;

  @Prop({ required: false })
  private placeholder: string;

  @Prop({ default: false })
  private disabled: boolean;

  @Prop({ default: false })
  private saveDisabled: boolean;

  private saveEvent() {
    this.$emit('save');
  }

  private titleChange(e: { target: HTMLInputElement }) {
    const value = e.target.value;
    this.$emit('input', value);
  }
}
